import { createAction } from '@reduxjs/toolkit';

export const requestFindActiveProgrammes = createAction('external-registration/findActiveProgrammes');
export const requestCreateMember = createAction('external-registration/createMember');
export const requestFlagMemberAsPaid = createAction('external-registration/flagMemberAsPaid');
export const requestVerifyMemberStatus = createAction('external-registration/verifyMemberStatus');
